import { AuthPermissions } from 'skipify-types';

import { useMerchant } from '../contexts/MerchantContext';

/**
 * Hook to check if the current user is a Skipify Admin
 * This follows React hook conventions and can be safely used at component top-level
 *
 * @returns boolean indicating if user has Skipify Admin permissions
 */
export const useIsSkipifyAdmin = (): boolean => {
  const { isSkipifyAdmin } = useMerchant();
  return isSkipifyAdmin;
};

/**
 * Hook to check if the current user is a Skipify User (has read:* or admin:* permissions)
 * This follows React hook conventions and can be safely used at component top-level
 *
 * @returns boolean indicating if user has Skipify User permissions
 */
export const useIsSkipifyUser = (): boolean => {
  const { isSkipifyUser } = useMerchant();
  return isSkipifyUser;
};

/** Organization owners (`manage:portal-users`) and Skipify admins may manage portal users. */
export const useCanManagePortalUsers = (): boolean => {
  const { canAccess, isSkipifyAdmin } = useMerchant();
  return isSkipifyAdmin || canAccess(AuthPermissions.MANAGE_PORTAL_USERS);
};
